// components/PreviewToggle/PreviewToggle.jsx
import React from "react";
import styles from "./Slidetab.module.scss";

export const PreviewToggle = ({ isActive, onToggle }) => {
  return (
    <div className={styles.previewContainer}>
      Preview Slides
      <div
        className={`${styles.toggleButton} ${isActive ? styles.activeToggle : ''}`}
        onClick={onToggle}
      >
        <div className={styles.toggleKnob} />
      </div>
    </div>
  );
};